import { StockStorageType } from '../models/supplier-stock-sync/stock-storage.type';
import { AllergenDto } from './allergen.dto';
import { BaseDto } from './base.dto';
import { CountryDto } from './country.dto';
import { DietDto } from './diet.dto';
import { MerchantDto } from './merchant.dto';
import { MerchantGroupDto } from './merchantGroup.dto';
import { RecipeDto } from './recipe.dto';
import { RecipeDetailDto } from './recipeDetail.dto';
import { StockCategoryDto } from './stockCategory.dto';
import { StockLocationDto } from './stockLocation.dto';
import { StockNutritionDto } from './stockNutrition.dto';
import { StockParDto } from './stockPar.dto';
import { StockStockLocationDto } from './stockStockLocation.dto';
import { StockUnitDto } from './stockUnit.dto';
import { SupplierDto } from './supplier.dto';
import { UnitConversionDto } from './unitConversion.dto';
import { VATRateDto } from './vat-rate.dto';
import {
  StockMerchantPurchasingDetailsDto
} from './stock-merchant-purchasing-details/stock-merchant-purchasing-details.dto';

export class StockDto extends BaseDto {
  name: string;
  isIngredient: boolean;
  startDate: Date;
  endDate: Date;
  displayName: string;
  selected: Boolean;
  isActive: Boolean;
  code: string;
  supplier: SupplierDto;
  supplierId: number;
  stockCategory: StockCategoryDto;
  stockCategoryId: number;
  stockCategoryLev2Id: number;
  stockCategoryLev2: StockCategoryDto;
  stockCategoryLev1Id: number;
  stockCategoryLev1: StockCategoryDto;
  stockUnit: StockUnitDto;
  vatRate: VATRateDto;
  vatRateId: number;
  merchant?: MerchantDto;
  merchantGroupId?: number;
  merchantGroup?: MerchantGroupDto;
  merchantId?: number;
  stockCaseQuantity: number;
  netSize: number;
  unitSize: number;
  unitCost: number;
  caseSize: number;
  caseCost: number;
  stockUnitId: number;
  caseSplit: boolean;
  keyLine: boolean;
  sub: boolean;
  subSupplier: number;
  subCode: number;
  yieldableProduct: boolean;
  hasSulphur: boolean;
  hasCelery: boolean;
  hasCereal: boolean;
  allergens?: AllergenDto[];
  diets?: DietDto[];
  nutrition?: StockNutritionDto;
  enabled: boolean;
  unitYield?: StockUnitDto;
  unitYieldQuantity?: number;
  stockId?: number;
  recipes?: RecipeDto[];
  recipeDetails?: RecipeDetailDto[];
  activeOrNot?: Boolean;
  stockLocations?: StockLocationDto[];
  stockStockLocations?: StockStockLocationDto[];
  lastModifiedYieldingDate?: Date;
  stockPar?: StockParDto[];
  tag: string;
  // isRecipe?: boolean;
  onContract: boolean;
  photoURL: string;

  supplierName?: string;

  //Related with select stock list
  amount?: number;
  unitConversion?: UnitConversionDto;
  cost?: number;
  orderServiceTypeId?: number;
  // Related with transfers
  transferCase?: number;
  transferUnit?: number;

  //Related to stock location order modal
  sharedSourceName?: string;
  stockMerchantPurchasingDetails?: StockMerchantPurchasingDetailsDto;

  countryOfOrigin?: CountryDto
  countryOfOriginId?: number;
  brandName?: string;
  storageType?: StockStorageType;
  shelfLifeFromProductionDays?: number;
  soldAsSingleUnit?: boolean;
  ingredients?: string;
  drsEnabled?: boolean;
  drsValue?: number;
}
